









































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Page2Interface } from '@/components/reports/vedomost/helpers/Vedomost.interface'
import List from '@/components/reports/vedomost/components/List.vue'
import CategoriesTable from '@/components/reports/vedomost/components/CategoriesTable.vue'
import TotalAmountTable from '@/components/reports/vedomost/components/TotalAmountTable.vue'

@Component({
  components: { List, CategoriesTable, TotalAmountTable }
})
export default class Page2 extends Vue {
  workersList = {
    title: 'Категории работников',
    data: [
      { number: '001', text: 'Основной работник' },
      { number: '100', text: 'Инвалид 1-2 группы' },
      { number: '010', text: 'Иностранный гражданин' },
      { number: '101', text: 'Участник/инвалид ВОВ' },
      { number: '102', text: 'Лица, приравненные к участникам ВОВ' },
      { number: '003', text: 'Пенсионер' },
      { number: '103', text: 'Частный предприниматель' },
      { number: '104', text: 'Арендодатель' },
      { number: '105', text: 'Гонорары, вознаграждения' },
      { number: '106', text: 'МОП' },
      { number: '107', text: 'Пенсионеры-МОП' }
    ]
  }
  codesList = {
    title: 'Коды списков',
    data: [
      { number: '007', text: 'Список №1' },
      { number: '006', text: 'Список №2' }
    ]
  }
  districtsList = {
    title: 'Коды высокогорья и отдаленных районов',
    data: [
      { number: '007', text: 'Высокогорье' },
      { number: '006', text: 'Отдаленные районы' }
    ]
  }
  signs = [
    { id: 'headName', title: 'Руководитель предприятия (организации)', sub1: 'Ф.И.О.', sub2: 'Роспись' },
    { id: 'accountantName', title: 'Главный бухгалтер', sub1: 'Ф.И.О.', sub2: 'Роспись' }
  ]
  formData = {}

  @Prop({ type: Object, default: () => ({}) }) pageData!: Page2Interface
  @Watch('pageData') onChangePageData(val: Page2Interface): void {
    this.formData = val
  }
}
